/**
 * table 排序小按钮
 */
export default {
  name: 'cellSort',
  props: {
    value: {
      type: [Boolean, Object],
    },
  },
  data() {
    return {
      data: this.value,
    }
  },
  watch: {
    data() {
      this.$emit('input', this.data)
    },
  },
  methods: {},
  render(h) {
    let sort = h(
      'span',
      {
        class: 'caret-wrapper',
      },
      [
        h('i', {
          class: `sort-caret ascending ${
            this.data == null || this.data == undefined ? '' : this.data ? 'sort-asc-active' : ''
          }`,
          on: {
            click: (e) => {
              if (~e.target.className.indexOf('sort-asc-active')) {
                e.target.className = e.target.className.replace(' sort-asc-active', '')
                this.data = null
              } else {
                e.target.className += ' sort-asc-active'
                this.data = true
              }
            },
          },
        }),
        h('i', {
          class: `sort-caret descending ${
            this.data == null || this.data == undefined ? '' : !this.data ? 'sort-des-active' : ''
          }`,
          on: {
            click: (e) => {
              if (~e.target.className.indexOf('sort-des-active')) {
                e.target.className = e.target.className.replace(' sort-des-active', '')
                this.data = null
              } else {
                e.target.className += ' sort-des-active'
                this.data = false
              }
            },
          },
        }),
      ]
    )

    return sort
  },
}
